import { addDays } from 'date-fns';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

//Types
import type { AffiliateStoreType } from './type';

const CONFIG = {
  //2 weeks
  expiration: 14,
};

export const AffiliateStore = create<AffiliateStoreType>()(
  persist(
    (set) => ({
      partner: null,
      notice: false,
      expiration: 0,
      upsert: (data) => {
        //Skip if not defined
        if (!data?.ticketingPlatformSlug) {
          return;
        }

        return set((state) => {
          //If same ticketingPlatformSlug, do not update the state.
          if (
            data?.ticketingPlatformSlug === state.partner?.ticketingPlatformSlug
          ) {
            return state;
          }

          return {
            partner: data,
            notice: true,
            expiration: Math.floor(
              addDays(new Date(), CONFIG.expiration).getTime() / 1000,
            ),
          };
        });
      },
      closeNotice: () => {
        return set({ notice: false });
      },
      clean: () => {
        return set({ partner: null, expiration: 0, notice: false });
      },
    }),
    {
      name: 'nf-affiliate',
      version: 1,
      partialize: (state) => ({
        partner: state.partner,
        expiration: state.expiration,
        notice: state.notice,
      }),
      onRehydrateStorage: () => (state) => {
        //After rehydration, if not cookie exists, clean the store.
        if (state?.partner && Date.now() > state.expiration * 1000) {
          state.clean();
        }
      },
    },
  ),
);
